// extracted by mini-css-extract-plugin
export var readonly = "_bv-1";
export var star = "_bv-0";